import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { parseCallBookSearch } from '@/lib/fundraising/bookFilters';
import { CallSheet } from '@/components/fundraising';

// One call book, with the person open over it and any order it's only being viewed in, in the URL
// (`?person=&sort=&dir=`).
// Fundraising:Manage.
export const Route = createFileRoute('/admin/fundraising/call-books/$sheetId')({
  validateSearch: parseCallBookSearch,
  beforeLoad: ({ context, params }) => {
    requireCapability(context, 'Fundraising', CapabilityTier.Manage, `/admin/fundraising/call-books/${params.sheetId}`);
  },
  component: CallSheetRoute,
});

function CallSheetRoute() {
  const { sheetId } = Route.useParams();
  const { person, sort, dir } = Route.useSearch();
  return <CallSheet sheetId={sheetId} person={person} sort={sort} dir={dir} />;
}
